import Cookies from 'js-cookie';
import jwtDecode from 'jwt-decode';
import { userConstants } from '../constants/userConstants';

const auth = Cookies.get('auth');
const refresh = Cookies.get('refresh');
let authDecoded;

if (auth) {
  authDecoded = jwtDecode(auth);
}
const user = JSON.parse(localStorage.getItem('user'));

let initialState = {};

if (auth && user) {
  initialState = {
    loggedIn: true,
    auth: {
      _id: authDecoded.id,
      token: auth,
      refreshToken: refresh,
    },
  };
} else {
  initialState = {};
}

export default function authentication(state = initialState, action) {
  switch (action.type) {
    case userConstants.LOGIN_REQUEST:
      return {
        loggingIn: true,
      };
    case userConstants.REQUEST_NEW_PASSWORD:
      return {
        requestNewPassword: true,
      };
    case userConstants.LOGIN_SUCCESS:
      return {
        loggedIn: true,
        auth: action.auth,
      };
    case userConstants.LOGIN_REFRESH_REQUEST:
      return {
        ...state,
        refreshingToken: true,
      };
    case userConstants.LOGIN_REFRESH_SUCCESS:
      return {
        loggedIn: true,
        auth: action.auth,
      };
    case userConstants.SUCCESS_NEW_PASSWORD:
      return {
        newPassword: true,
      };
    case userConstants.LOGIN_FAILURE:
      return {};
    case userConstants.LOGIN_REFRESH_FAILURE:
      return {};
    case userConstants.FAILURE_NEW_PASSWORD:
      return {};
    case userConstants.LOGOUT:
      return {};
    default:
      return state;
  }
}
